import React from "react";
import styled from "styled-components";
import { MAX_WIDTH } from "sweet-web/lib/constants";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${colors.lightGray};
`;

const Tab = styled.a<{ active: boolean }>`
  display: inline-block;
  text-decoration: none;
  padding: 10px 0px;
  margin-right: 40px;
  font-size: 14px;
  font-weight: 600;
  color: ${props => (props.active ? colors.nearBlack : colors.gray)};
  background: none;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  border-bottom: 2px solid
    ${props => (props.active ? colors.nearBlack : "transparent")};
  &:hover {
    color: ${colors.nearBlack};
    border-bottom-color: ${colors.nearBlack};
  }
`;

type Props = {
  url: string;
  tabs: Array<{
    name: string;
    title: string;
    path: string;
  }>;
};

const TabBar: React.FC<Props> = props => (
  <Wrapper>
    {props.tabs.map(tab => (
      <Tab
        key={`tab-${tab.name}`}
        active={props.url == tab.path}
        href={tab.path}
      >
        {tab.title}
      </Tab>
    ))}
  </Wrapper>
);

export default TabBar;
